import store from '../redux/store';
import { StateManager } from '../redux/stateManager';
import { SettingInfo } from '../constants/type.constant';

export const getSettingInfo = (name: string, returnType: 'normal' | 'value' = 'normal', propsInfo?: SettingInfo[]) => {
  let { settingInfo } = store.getState();
  if (propsInfo) settingInfo = propsInfo;
  if (!settingInfo.length) settingInfo = StateManager.getFromCache('settingInfo')

  let result = null;
  for (let i = 0; i < settingInfo.length; i++) {
    const item = settingInfo[i];
    if (item.name === name) {
      result = returnType === 'normal' ? item : item.value;
      break;
    }
  }
  return result;
};
/*settingInfo :

Array [
  SettingInfo {
    "id": 1,
    "name": "package-fee",
    "value": Object {
      "init": true,
      "menu_id": 9,
    },
  },
  SettingInfo {
    "id": 2,
    "name": "rule-global-turn-limit",
    "value": Object {
      "enable": true,
      "init": true,
      "turn_dishes": "3",
      "turn_mins": "1",
    },
  },
  SettingInfo {
    "id": 3,
    "name": "rule-local-dish-limit",
    "value": Object {
      "enable": true,
      "init": true,
    },
  },
  SettingInfo {
    "id": 9,
    "name": "rule-global-turn-max-number",
    "value": 999,
  },
  SettingInfo {
    "id": 10,
    "name": "rule-dis-xml-out-put-path",
    "value": "",
  },
  SettingInfo {
    "id": 11,
    "name": "rule-printer-font-size",
    "value": Object {
      "item_name1": 0,
      "item_name2": 0,
      "quantity": 0,
      "table": 0,
    },
  },
  SettingInfo {
    "id": 12,
    "name": "rule-one-dish-one-order",
    "value": Object {
      "printer": Array [],
    },
  },
  SettingInfo {
    "id": 13,
    "name": "rule-print-auto-order",
    "value": Object {
      "status": true,
    },
  },
  SettingInfo {
    "id": 14,
    "name": "rule-autonomous-meal",
    "value": Object {
      "status": false,
    },
  },
  SettingInfo {
    "id": 15,
    "name": "kwa-check-order-update-time",
    "value": "2020-01-03 10:00:53",
  },
  SettingInfo {
    "id": 16,
    "name": "active-push-turn",
    "value": Object {
      "status": true,
    },
  },
  SettingInfo {
    "id": 17,
    "name": "order-restaurant-mode",
    "value": Object {
      "status": true,
    },
  },
  SettingInfo {
    "id": 18,
    "name": "suffix-of-invoice-number",
    "value": 223,
  },
  SettingInfo {
    "id": 19,
    "name": "default-selection-menu",
    "value": Object {
      "defaultMenu": Array [
        3,
        1,
      ],
    },
  },
  SettingInfo {
    "id": 20,
    "name": "hide-menu-by-default",
    "value": Object {
      "hideMenu": Array [
        6,
        7,
        8,
        5,
        9,
      ],
    },
  },
  SettingInfo {
    "id": 21,
    "name": "show-item-name1-or-item-name2",
    "value": Object {
      "showItemName1": true,
    },
  },
  SettingInfo {
    "id": 22,
    "name": "menu-dishes-sort",
    "value": "item_name1 ASC",
  },
  SettingInfo {
    "id": 23,
    "name": "fast-order-precision-rules",
    "value": 1,
  },
  SettingInfo {
    "id": 24,
    "name": "delivery-kitchen-head-empty-line",
    "value": 0,
  },
  SettingInfo {
    "id": 25,
    "name": "send-order-print-dish-name-type",
    "value": 1,
  },
  SettingInfo {
    "id": 26,
    "name": "disable-order-time-period",
    "value": Object {
      "time": Array [],
    },
  },
  SettingInfo {
    "id": 27,
    "name": "customer-first-screen",
    "value": 1,
  },
  SettingInfo {
    "id": 28,
    "name": "name1-and-Name2-only-show-one-line-in-send-order",
    "value": Object {
      "line": 2,
    },
  },
]
*/
